import { render, staticRenderFns } from "./create-doctor-order.vue?vue&type=template&id=7a7d2280&"
import script from "./create-doctor-order.vue?vue&type=script&lang=js&"
export * from "./create-doctor-order.vue?vue&type=script&lang=js&"
import style0 from "./create-doctor-order.vue?vue&type=style&index=0&id=7a7d2280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports